var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex gap-2 items-center",class:[
    {
      'bg-yellow-light': _vm.value && _vm.badge,
      'bg-gray-lightest': !_vm.value && _vm.badge,
      'py-1 px-2 rounded-1': _vm.badge,
    } ],on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('icon',{staticClass:"cursor-pointer",attrs:{"icon":_vm.value ? _vm.StarSvg : _vm.StarOutlineSvg}}),(_vm.badge)?_c('span',{staticClass:"uppercase text-xxs font-bold"},[_vm._v(" "+_vm._s(_vm.value ? _vm.$t('common.unmark-as-important') : _vm.$t('common.mark-as-important'))+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }